import React from "react";
import "./Modal.scss";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { CustomButton } from "components/form";
import { LiaTimesSolid } from "react-icons/lia";

// Custom Modal
export const CustomModal = ({
  show,
  handleClose,
  children,
  className,
  size,
  action,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      className={`custom_modal ${className}`}
      size={size}
    >
      <Modal.Body>
        <div className="modal_content">
          <button className="cancel_button" onClick={handleClose}>
            <FaTimes />
          </button>
          {children}
        </div>
      </Modal.Body>
    </Modal>
  );
};
// Delete Modal
export const PopupModal = ({
  show,
  handleClose,
  title,
  content,
  action,
  onShow,
  buttonLoader,
}) => {
  console.log(buttonLoader, "buttonLoader");
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
        className="custom_modal delete_modal"
        onShow={action}
      >
        <Modal.Body>
          <h3 className="title">{title}</h3>
          <p className="content">{content}</p>
          <div className="button_wrap">
            <button
              type="button"
              className="button light"
              onClick={handleClose}
            >
              No
            </button>
            <button
              ref={buttonLoader}
              type="button"
              className="button"
              onClick={onShow}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

//
